export default "__VITE_ASSET__Cn17yP_G__"